// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface UserBadge {
  id: string;
  badge_id: string;
  earned_at: string;
  badge: {
    id: string;
    name: string;
    description: string;
    emoji: string;
    requirement_type: string;
    requirement_count: number;
  };
}

export interface AvailableBadge {
  id: string;
  name: string;
  description: string;
  emoji: string;
  requirement_type: string;
  requirement_count: number;
  sort_order: number | null;
  earned: boolean;
  earned_at?: string;
}

export function useUserBadges(profileId: string | undefined) {
  return useQuery({
    queryKey: ['user-badges', profileId],
    queryFn: async () => {
      if (!profileId) throw new Error('No profile ID');

      // Get all active badges
      const { data: allBadges, error: badgesError } = await supabase
        .from('wall_badges')
        .select('id, name, description, emoji, requirement_type, requirement_count, sort_order')
        .eq('is_active', true)
        .order('sort_order');

      if (badgesError) throw badgesError;

      // Get user's earned badges
      const { data: earnedBadges, error: earnedError } = await supabase
        .from('wall_user_badges')
        .select(`
          id,
          badge_id,
          earned_at
        `)
        .eq('profile_id', profileId);

      if (earnedError) throw earnedError;

      // Create a map of earned badges
      const earnedMap = new Map(
        (earnedBadges || []).map(eb => [eb.badge_id, eb.earned_at])
      );

      // Combine into available badges with earned status
      const badges: AvailableBadge[] = (allBadges || []).map(badge => ({
        ...badge,
        earned: earnedMap.has(badge.id),
        earned_at: earnedMap.get(badge.id),
      }));

      return badges;
    },
    enabled: !!profileId,
  });
}
